import React from "react";
import "./Legal.css";

function Terms() {
  return (
    <div className="legal-container">

      <h1>Terms and Conditions</h1>
      <p className="date">Last Updated: March 2026</p>

      <p>
        Welcome to <b>TheBlogsSphere</b>. By using this platform,
        you agree to follow all terms written below.
        If you do not agree, please do not use this website.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>By using this platform, you accept these Terms.</p>

      <h2>2. User Accounts</h2>
      <ul>
        <li>Provide correct information</li>
        <li>Keep your password safe</li>
        <li>You are responsible for your account</li>
      </ul>

      <h2>3. User Content</h2>
      <ul>
        <li>No illegal content</li>
        <li>No copyright violation</li>
        <li>No harmful links</li>
        <li>No abusive content</li>
      </ul>

      <h2>4. Account Suspension</h2>
      <p>We can suspend or remove any account if rules are broken.</p>

      <h2>5. Advertisement Policy</h2>
      <p>Our platform allows paid advertisements. Ads are shown based on selected views.</p>
      <ul>
        <li>No refund after ad starts</li>
        <li>No guarantee for followers or likes</li>
        <li>Views counted when ad shown</li>
      </ul>

      <h2>6. Payment Policy</h2>
      <ul>
        <li>Payment required before service</li>
        <li>No refund after start</li>
        <li>Prices may change anytime</li>
      </ul>

      <h2>7. Prohibited Activities</h2>
      <ul>
        <li>No hacking</li>
        <li>No spam</li>
        <li>No illegal ads</li>
        <li>No fake content</li>
      </ul>

      <h2>8. Third-Party Ads</h2>
      <p>We show ads from third-party ad networks such as Monetag. These ads are automatic and not fully controlled by us.</p>
      <p>Clicking ads is safe, but any payment, download, or personal data sharing is your own decision.</p>
      <p>TheBlogsSphere is not responsible for any loss, scam, or damage caused by ads.</p>

      <h2>9. Safety Notice</h2>
      <ul>
        <li>Do not pay money on unknown sites</li>
        <li>Do not install unknown apps</li>
        <li>Do not share OTP / bank / card details</li>
      </ul>

      <h2>10. Service Availability</h2>
      <p>Service may stop due to maintenance, server issue, or update.</p>

      <h2>11. Limitation of Liability</h2>
      <p>We are not responsible for user content, ads, or external links.</p>

      <h2>12. Changes to Terms</h2>
      <p>Terms may change anytime. Using this site means you accept changes.</p>

      <h2>13. Reward & Contest Policy</h2>
      <p>TheBlogsSphere run Monthly contests to reward top bloggers based on activity, posts, likes, and user engagement.</p>
      <ul>
        <li>Winners are selected after manual verification</li>
        <li>Fake activity will cancel reward</li>
        <li>Decision of admin is final</li>
      </ul>
      <p>Winners will receive email only to their registered email address.</p>
      <p>We will ask only for Name and GPay / PhonePe number to send reward.</p>
      <p>You must reply from the same registered email. Reward will be sent based on the first response received from that email.</p>
      <p>If you share your email with others, and someone sends wrong details, TheBlogsSphere is not responsible for wrong payment.</p>
      <p>If winner does not reply before given time, reward may be cancelled.</p>
      <p>Showing name on leaderboard does not guarantee reward. Reward will be given only after verification.</p>
      <p>TheBlogsSphere has full right to cancel, delay, or change reward rules anytime.</p>

      <h2>14. Startup Ads Notice</h2>
      <p>This platform is a startup project. To support server cost, we use ads.</p>
      <ul>
        <li>Inline Ads</li>
        <li>Direct Link Ads</li>
        <li>Banner Ads</li>
      </ul>
      <p>Ads may appear anywhere on the site.</p>
      <p>Do NOT pay money, do NOT install unknown apps, do NOT share personal details.</p>
      <p>Ads are from ad networks. We do not fully control them.</p>
      <p>We earn money only from ads.</p>

      <h2>15. Chat Feature Terms & Conditions</h2>
      <p>To ensure privacy and prevent unwanted messages, our chat feature follows these rules:</p>
      <p>1. Users can send and receive messages only when both users follow each other (mutual follow).</p>
      <p>2. If one user unfollows the other, the ability to send new messages will be disabled immediately.</p>
      <p>3. Existing chat history may remain visible, but no new messages can be sent until both users follow each other again.</p>
      <p>4. If a user blocks another user, messaging and other interactions between them will be restricted according to our platform policies.</p>
      <p>5. Users must not use the chat feature for spam, harassment, abusive content, illegal activities, or sharing harmful material.</p>
      <p>6. We reserve the right to suspend or permanently disable chat access for users who violate these terms.</p>
      <p>7. By using the chat feature, you agree to follow these Terms & Conditions and our community guidelines.</p>
      <p><b>Important:</b> Chat is available only for mutually connected users. Both users must follow each other to start or continue a conversation.</p>

      <h2>16. Disclaimer of Warranties</h2>
      <p>This platform is provided "AS IS" and "AS AVAILABLE," without warranties of any kind, whether express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, non-infringement, accuracy, or uninterrupted operation.</p>
      <p>We do not guarantee that the platform will be error-free, secure, virus-free, or available at all times. You use this platform entirely at your own risk.</p>

      <h2>17. Indemnification</h2>
      <p>You agree to indemnify, defend, and hold harmless TheBlogsSphere, its founders, team members, affiliates, and partners from and against any and all claims, damages, losses, liabilities, costs, and expenses (including reasonable legal fees) arising out of or related to:</p>
      <ul>
        <li>Your use or misuse of the platform</li>
        <li>Content you post, upload, or share</li>
        <li>Your violation of these Terms</li>
        <li>Your violation of any law or third-party right</li>
        <li>Any dispute between you and another user</li>
      </ul>

      <h2>18. Limitation of Liability (Extended)</h2>
      <p>To the maximum extent permitted by law, TheBlogsSphere and its team shall not be liable for any indirect, incidental, special, consequential, exemplary, or punitive damages, including loss of profit, data, goodwill, or opportunity, arising from your use of the platform, even if we have been advised of the possibility of such damages.</p>
      <p>Our total liability for any claim relating to the platform shall not exceed the amount you have paid to TheBlogsSphere, if any, in the twelve (12) months preceding the claim, or ₹500, whichever is lower.</p>

      <h2>19. Intellectual Property Rights</h2>
      <p>The TheBlogsSphere name, logo, design, layout, source code, and branding are the exclusive property of TheBlogsSphere and may not be copied, reproduced, distributed, or used without prior written permission.</p>
      <p>By posting content on this platform, you grant TheBlogsSphere a non-exclusive, worldwide, royalty-free license to host, display, distribute, and promote your content within the platform and its promotional materials. You retain ownership of your original content.</p>
      <p>You confirm that you own or have proper rights to any content you upload, and that it does not infringe any third-party copyright, trademark, or intellectual property right.</p>

      <h2>20. Account Termination Rights</h2>
      <p>TheBlogsSphere reserves the right to suspend, restrict, or permanently terminate any user account, with or without prior notice, and with or without reason, including but not limited to violation of these Terms, suspected fraud, abuse, fake activity, or any action that may harm the platform or its users.</p>
      <p>Upon termination, your right to use the platform ends immediately. We are not obligated to restore any account, content, or data after termination.</p>

      <h2>21. No Guarantee of Earnings or Results</h2>
      <p>TheBlogsSphere does not guarantee any income, followers, views, engagement, rewards, or business results from using the platform. Any figures, examples, or testimonials shown are not a promise or guarantee of similar results.</p>

      <h2>22. Force Majeure</h2>
      <p>TheBlogsSphere shall not be held responsible for any delay, failure, or interruption of service caused by events beyond our reasonable control, including but not limited to server outages, internet failures, natural disasters, government action, power failure, cyberattacks, or third-party service failures (hosting, payment gateways, ad networks, etc.).</p>

      <h2>23. Governing Law & Dispute Resolution</h2>
      <p>These Terms shall be governed by and interpreted in accordance with the laws of India, without regard to conflict of law principles.</p>
      <p>Any dispute, controversy, or claim arising out of or relating to these Terms or the use of this platform shall first be attempted to be resolved amicably. If unresolved, the dispute shall be subject to the exclusive jurisdiction of the courts located in India.</p>

      <h2>24. Age Restriction</h2>
      <p>This platform is intended for users aged 13 and above. If you are under the age of 18, you confirm that you have permission from a parent or legal guardian to use this platform. TheBlogsSphere reserves the right to terminate accounts found to be in violation of this policy.</p>

      <h2>25. Content Moderation & Removal</h2>
      <p>TheBlogsSphere reserves the right, but is not obligated, to monitor, review, edit, or remove any user content at its sole discretion, without prior notice, if such content is believed to violate these Terms, applicable law, or community standards.</p>

      <h2>26. Severability</h2>
      <p>If any provision of these Terms is found to be invalid, illegal, or unenforceable by a court of competent jurisdiction, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall continue in full force and effect.</p>

      <h2>27. Entire Agreement</h2>
      <p>These Terms, together with our Privacy Policy and any other published platform policies, constitute the entire agreement between you and TheBlogsSphere regarding your use of the platform, and supersede any prior agreements or understandings.</p>

      <h2>28. Assignment</h2>
      <p>TheBlogsSphere may assign, transfer, or delegate its rights and obligations under these Terms at any time without notice. You may not assign or transfer your rights under these Terms without our prior written consent.</p>

      <h2>29. Contact for Legal Matters & Refund Policy</h2>
      <p>For any legal notices, complaints, or concerns regarding these Terms, please contact us through the official contact details provided on this platform <span>theblogssphere@gmail.com</span>.</p>
      <div className="legal-refund-box">
        <h3>Refund Policy - Strictly No Refund:</h3>
        <p><strong>1. Pro Creator Fee (₹29) & Watch Pro Fee (₹19) & Love Sphere & Advertisements:</strong> All payments made on The Blogs Sphere platform are strictly non-refundable. This includes Pro activation, unlocking Pro blogs, Love Sphere features, and any advertisement / promotion payments.</p>
        <p><strong>2. Content Unlocked = No Refund:</strong> Once you pay and the content is unlocked or service is activated, no refund will be given for any reason like "did not like the content", "information was not useful", "paid by mistake", or "changed mind".</p>
        <p><strong>3. When Refund Is Considered (Only Exception):</strong> Refund will only be considered in case of a genuine technical failure from our side, such as:</p>
        <ul>
          <li>Content not loading / not accessible due to our server error</li>
          <li>Payment deducted but Pro access / Love Sphere / Ad not activated</li>
          <li>Server continuously slow or down and content is not viewable at all</li>
        </ul>
        <p>Even in the above cases, refund will only be issued if our technical team fails to fix the issue within 48 hours of your complaint.</p>
        <p><strong>4. How to Claim:</strong> To claim for a technical issue, you must email us at <span>theblogssphere@gmail.com</span> within 24 hours of payment with valid payment screenshot and issue proof. No claims after 24 hours will be accepted.</p>
      </div>

      {/* ✅ ADVERTISING TERMS - SECTION 30 TO 51 */}

      <h2>30. TheBlogSphere Advertising Terms & Conditions</h2>
      <p><b>The advertiser must accept the following before payment.</b></p>

      <h2>31. Campaign Submission</h2>
      <p>Advertisers may submit supported advertisement formats including text, image/banner and video advertisements. The Advertiser is responsible for providing accurate business, contact, advertising and destination-website information. Submission of a campaign does not guarantee approval or publication.</p>

      <h2>32. Review and Approval</h2>
      <p>All advertisements are subject to TheBlogSphere review. TheBlogSphere may reject, modify, pause, restrict or remove an advertisement that violates applicable law, platform policies, security requirements, intellectual-property rights, user-safety requirements or other applicable standards. Approval does not constitute endorsement or verification of the advertiser, product, service or claims.</p>

      <h2>33. Pricing</h2>
      <p>Current introductory advertising packages may include:</p>
      <ul>
        <li>Text Ad — ₹99 — estimated 500–1,000 impressions</li>
        <li>Image Ad — ₹199 — estimated 750–1,500 impressions</li>
        <li>Video Ad — ₹299 — estimated 1,500–2,500 impressions</li>
      </ul>
      <p>Prices and packages may be changed by TheBlogSphere for future campaigns. The final price shown at checkout and accepted by the Advertiser applies to the submitted Campaign.</p>

      <h2>34. Estimated Impressions</h2>
      <p>Displayed impression ranges are estimates for planning purposes. For example: 750–1,500 estimated impressions does not mean that exactly 750 or exactly 1,500 impressions will necessarily be delivered.</p>
      <p>Actual delivery can vary due to:</p>
      <ul>
        <li>Available advertising inventory</li>
        <li>User activity</li>
        <li>Audience eligibility</li>
        <li>Category targeting</li>
        <li>City targeting</li>
        <li>Frequency limitations</li>
        <li>Platform traffic</li>
        <li>Campaign competition</li>
        <li>Technical conditions</li>
      </ul>
      <p>Estimated impressions are not a guarantee of clicks, sales, leads, revenue or any other business outcome.</p>

      <h2>35. Campaign Duration</h2>
      <p>Unless otherwise specified, the maximum Campaign Duration is up to 14 days. A Campaign may finish before the maximum duration if the applicable minimum impression target is reached. The Campaign will end when either the minimum applicable impression target is reached; or the Campaign end date is reached, whichever occurs first. The Campaign will not continue beyond its stated end date unless expressly extended by TheBlogSphere.</p>

      <h2>36. Impression Measurement</h2>
      <p>An impression is counted only after the advertisement satisfies TheBlogSphere's impression measurement requirements. An advertisement being returned by an API does not automatically constitute an impression. TheBlogSphere may use visibility, duration and technical validation rules to determine qualifying impressions.</p>

      <h2>37. Audience Targeting</h2>
      <p>Advertisers may select supported categories and city-level targeting. Advertisers do not receive exact user GPS locations or exact user addresses. TheBlogSphere may automatically expand delivery to nearby city-level audiences if the selected city's eligible audience is insufficient, according to internal delivery rules. Such expansion does not guarantee a particular city, number of users or number of impressions.</p>

      <h2>38. Personalised Advertising</h2>
      <p>Where enabled and permitted, TheBlogSphere may use non-sensitive category-level activity to improve advertising relevance. Users may disable personalised advertising through available Platform settings. When personalised advertising is disabled, TheBlogSphere may use contextual, general or other permitted non-personalised advertising methods. Sensitive personal information will not intentionally be used for advertising targeting where prohibited by applicable law or Platform policy.</p>

      <h2>39. Frequency Limitation</h2>
      <p>Unless otherwise specified, the same advertisement will generally not be shown to the same user again within 12 hours after a qualifying impression. This limitation may affect campaign delivery speed.</p>

      <h2>40. Payment</h2>
      <p>Campaign payment must be completed using the payment method provided by TheBlogSphere. A Campaign will only become active after required approval and successful server-side payment verification. Frontend payment-success messages alone do not activate a Campaign.</p>

      <h2>41. Refunds and Cancellation</h2>
      <p>Refund eligibility depends on Campaign status, delivery already received, applicable refund rules and applicable law. Impressions already validly delivered may be excluded from any refund calculation. If a Campaign is rejected, paused or removed due to violation of these Terms or applicable law, refund eligibility will be determined according to the applicable refund policy and law.</p>

      <h2>42. Advertiser Responsibility</h2>
      <p>The Advertiser is responsible for:</p>
      <ul>
        <li>Accuracy of advertising claims</li>
        <li>Legality of products and services</li>
        <li>Intellectual-property rights</li>
        <li>Trademark rights</li>
        <li>Uploaded creative materials</li>
        <li>Destination websites</li>
        <li>Applicable advertising and consumer-protection requirements</li>
      </ul>
      <p>Advertisers must not submit fraudulent, deceptive or misleading advertisements.</p>

      <h2>43. Destination URLs</h2>
      <p>TheBlogSphere may perform automated and manual checks on destination URLs. HTTPS alone does not establish that a destination website is safe or legitimate. TheBlogSphere may reject or block suspicious, malicious, deceptive or unsafe destinations. No automated security system can guarantee detection of every malicious or deceptive website.</p>

      <h2>44. Clicks and Results</h2>
      <p>Clicks, impressions, reach and video views do not guarantee: Sales, Leads, Purchases, Revenue, Conversions, Website traffic quality, Customer acquisition.</p>

      <h2>45. Invalid Activity</h2>
      <p>Advertisers must not artificially generate impressions, clicks or other advertising activity. TheBlogSphere may filter or invalidate activity that it determines to be fraudulent, automated or otherwise invalid.</p>

      <h2>46. Campaign Suspension</h2>
      <p>TheBlogSphere may pause or remove a Campaign for: Security reasons, Legal compliance, Policy violations, Payment problems, Technical issues, User safety, Invalid activity.</p>

      <h2>47. Platform Availability</h2>
      <p>TheBlogSphere will make reasonable efforts to operate the advertising system but does not guarantee uninterrupted or error-free service. Technical failures, maintenance, network problems and other events may affect Campaign delivery.</p>

      <h2>48. Analytics</h2>
      <p>Advertisers may receive: Impressions, Unique reach, Clicks, CTR, Video views, Campaign status, Campaign dates. Metrics may be subject to technical processing, filtering and correction.</p>

      <h2>49. Intellectual Property</h2>
      <p>The Advertiser grants TheBlogSphere the necessary rights to host, process, display and distribute submitted advertising materials for the purpose of operating the Campaign. The Advertiser confirms that it has the necessary rights and permissions for submitted materials.</p>

      <h2>50. No Endorsement</h2>
      <p>Displaying an advertisement does not mean TheBlogSphere endorses or guarantees the advertiser, product, service, claims or destination website.</p>

      <h2>51. Changes to Advertising Terms</h2>
      <p>TheBlogSphere may modify advertising formats, pricing, delivery rules, targeting methods and other advertising features. Changes generally apply to future Campaigns unless otherwise communicated or required by law.</p>

      <h2>52. Acceptance of Advertising Terms</h2>
      <p>By submitting a Campaign and completing payment, the Advertiser confirms that they have read and accepted these Advertising Terms & Conditions.</p>

    </div>
  );
}

export default Terms;